import { Link } from "@reach/router"
import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"
import BookCalendar from "../bookCalendar"
import moment from "moment"
import Fade from "react-reveal/Fade"

const YachtAvailibility = ({ vesselId, vesselName, vesselCapacity, multiDay }) => {
    const [daysData, setDaysData] = React.useState([])
    const [date, setDate] = React.useState({})
    const [error, setError] = React.useState(null)

    return (
        <div className="container-xxl gradient-booking-calendar yacht-booking-margin-correction">
            <div className="row ">
                <div className="col-12 position-relative overflow-x-clip col-md-6 d-flex flex-column align-items-center justify-content-center">
                    <StaticImage
                        className="background-availibility-water d-md-none"
                        src="../../images/water3.png"
                        alt="Water Background-1"
                    />
                    <StaticImage
                        className="background-availibility-water d-none d-md-block"
                        src="../../images/water4.png"
                        alt="Water Background-2"
                    />
                    <Fade delay={300} duration={1500}>
                        <div className="d-none d-md-block z-index-3 yacht-availibility-text ps-inside">
                            <h2>{vesselName}’s availability</h2>
                            <p className="d-none">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                                dolore magna aliqua. Ut enim ad minim veniam.
                            </p>
                        </div>
                    </Fade>
                    <StaticImage className="yacht-booking-frame" src="../../images/yacht-frame1.png" alt="Frame-1" />
                    <StaticImage className="yacht-girl-frame d-none d-md-block" src="../../images/about-frame5.png" alt="Frame-2" />
                </div>
                <div className="col-12 d-md-none">
                    <Fade delay={300} duration={1500}>
                        <h2>{vesselName}’s availability</h2>
                        <p className="d-none">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                            dolore magna aliqua. Ut enim ad minim veniam.
                        </p>
                    </Fade>
                </div>
                <Fade delay={300} duration={1500}>
                    <div className="col-12 col-md-6 d-flex flex-column align-items-md-center justify-content-md-center calendar-wrapper-vessel">
                        <BookCalendar
                            daysData={daysData}
                            setDaysData={setDaysData}
                            yachtPage
                            vesselId={vesselId}
                            from={date.from}
                            to={date.to}
                            setData={setDate}
                            setError={setError}
                            multiSelect={multiDay}
                        />

                        <div className="pt-5 pb-2">
                            <Link
                                to="/book"
                                state={{
                                    vesselId: vesselId,
                                    from: moment(date?.from).toISOString(),
                                    to: date?.to ? moment(date?.to).toISOString() : moment(date?.from).toISOString(),
                                    vesselName: vesselName,
                                    vesselCapacity: vesselCapacity,
                                    multiDay
                                }}
                                className={`button fill light-background me-3 ${!date?.from ? "link-disabled" : ""}`}
                            >
                                book this yacht
                            </Link>
                        </div>
                        <StaticImage className="yacht-girl-frame d-md-none" src="../../images/about-frame5.png" alt="Frame-3" />
                    </div>
                </Fade>
            </div>
        </div>
    )
}

export default YachtAvailibility
